// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__wAIwz","image":"App_image__2XJqg"};